/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { AuthGuard } from '../auth.guard';

import { SettingsComponent } from '../settings/settings.component';
import { SettingsDomainsComponent } from '../settings/settings-domains/settings-domains.component';
import { SettingsIntegrationComponent } from '../settings/settings-integration/settings-integration.component';
import { SettingsContactComponent } from '../settings/settings-contact/settings-contact.component';
import { SettingsInboxesComponent } from '../settings/settings-inboxes/settings-inboxes.component';
import { SettingsBotComponent } from '../settings/settings-bot/settings-bot.component';
import { SettingsUsersComponent } from '../settings/settings-users/settings-users.component';
import { SettingsSubscriptionComponent } from '../settings/settings-subscription/settings-subscription.component';
import { InboxesAuthComponent } from '../settings/settings-inboxes/inboxes-auth/inboxes-auth.component';
import { BotAuthComponent } from '../settings/settings-bot/bot-auth/bot-auth.component';
import { SettingsPrivacyComponent } from '../settings/settings-privacy/settings-privacy.component';

export const settingsRouterConfig = [
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [AuthGuard],
    data: { role: 'user', title: 'Settings - My Profile', uiTitle: 'My Profile' }
  },
  {
    path: 'settings/domains',
    component: SettingsDomainsComponent,
    canActivate: [AuthGuard],
    data: { role: 'user', title: 'Settings - Domains and Forwarding', uiTitle: 'Domains and Forwarding' }
  },
  {
    path: 'settings/integration',
    component: SettingsIntegrationComponent,
    canActivate: [AuthGuard],
    data: { role: 'user', title: 'Settings - Integrations', uiTitle: 'Integrations' }
  },
  {
    path: 'settings/integration/:id',
    component: SettingsIntegrationComponent,
    canActivate: [AuthGuard],
    data: { role: 'user', title: 'Settings - Integrations', uiTitle: 'Integrations' }
  },
  {
    path: 'settings/inboxes',
    component: SettingsInboxesComponent,
    canActivate: [AuthGuard],
    data: { role: 'user', title: 'Settings - Inboxes', uiTitle: 'Inboxes' }
  },
  {
    path: 'settings/bot',
    component: SettingsBotComponent,
    canActivate: [AuthGuard],
    data: { role: 'user', title: 'Settings - Email Bot', uiTitle: 'Email Bot' }
  },
  {
    path: 'settings/ignore',
    component: SettingsContactComponent,
    canActivate: [AuthGuard],
    data: { role: 'user', title: 'Settings - Ignore Domains', uiTitle: 'Ignore Domains' }
  },
  {
    path: 'settings/users',
    component: SettingsUsersComponent,
    canActivate: [AuthGuard],
    data: { role: 'user', title: 'Settings - Users', uiTitle: 'Users' }
  },
  {
    path: 'settings/privacy',
    component: SettingsPrivacyComponent,
    canActivate: [AuthGuard],
    data: { role: 'manager', title: 'Settings - Data Privacy', uiTitle: 'Data Privacy' }
  },
  {
    path: 'settings/subscription',
    component: SettingsSubscriptionComponent,
    canActivate: [AuthGuard],
    data: { role: 'admin', title: 'Settings - Subscription', uiTitle: 'Subscription' }
  },
  {
    path: 'settings/inboxes/auth/:id',
    component: InboxesAuthComponent,
    canActivate: [AuthGuard],
    data: { role: 'public', title: 'Gmail Auth', uiTitle: 'Gmail Auth' }
  },
  {
    path: 'settings/bot/auth/:id',
    component: BotAuthComponent,
    canActivate: [AuthGuard],
    data: { role: 'manager', title: 'Gmail Auth', uiTitle: 'Gmail Auth' }
  }
];



// WEBPACK FOOTER //
// ./client/app/routes/settings.routes.ts